// @ts-nocheck

import React from 'react';
import styled, { css } from 'styled-components';

import combobooster from '../../assets/img/betshare/optionnal/combobooster.png';
import { ReactComponent as ComboPicto } from '../../assets/svg/chain.svg';
import { ReactComponent as MyMatchIcon } from '../../assets/svg/mymatch.svg';
import SportIconSvg from '../SportIconSvg';

const queryText = css`
  @media screen and (max-width: 600px) {
    font-size: 1em;
  }

  @media screen and (max-width: 400px) {
    font-size: 0.7em;
  }
`;

const queryTitle = css`
  @media screen and (max-width: 600px) {
    font-size: 1.1em;
  }

  @media screen and (max-width: 400px) {
    font-size: 0.9em;
    white-space: nowrap;
  }
`;

const Wrap = styled.div`
  min-height: 3em;
  text-align: center;
  color: #333;
  width: 100%;
  opacity: ${({ $isCancelled }) => ($isCancelled ? 0.5 : 1)};
`;

const WrapCol = styled.div`
  display: flex;
  justify-content: space-between;
  box-sizing: border-box;
  position: relative;
  width: 100%;
`;

const ColLeft = styled.div`
  position: relative;
  max-width: calc(100% - 130px);
  width: 100%;
`;

const ColRight = styled.div`
  min-width: 130px;
  text-align: right;
  text-transform: uppercase;
  margin-bottom: 0.5em;
`;

const P = styled.p`
  font-family: BettingPoliticaExtraBold, sans-serif;
  color: #fff;
  margin: 0 0 0.2em 0;
  line-height: 1.2;
  position: relative;
  overflow: hidden;
  text-overflow: ellipsis;
  ${queryText}
`;

const Title = styled(P)`
  display: flex;
  align-items: center;
  text-transform: uppercase;
  font-size: 1.4em;
  text-align: left;
  ${queryTitle}
`;

const WinningsAmount = styled(P)`
  font-size: 1.4em;
  text-align: right;
  color: ${({ theme }) => theme.common.colors.secondary};
  ${queryTitle}
`;

const SpanEllipsis = styled.span`
  position: relative;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const Span = styled(SpanEllipsis)`
  margin: 0 0.4em;
  ${queryText}
`;

const StyledMyMatchIcon = styled(MyMatchIcon)`
  display: block;
  width: auto;
  height: 1em;
  color: #fff;
  margin-bottom: 0.2em;
`;

const cssIcon = css`
  min-width: 1em;
  min-height: 1em;
  max-width: 1em;
  max-height: 1em;
  margin-right: 0.4em;
`;

const ComboIcon = styled(ComboPicto)`
  ${cssIcon}
`;

const StyledSportIcon = styled(SportIconSvg)`
  ${cssIcon}
`;

const BetTitle = styled(P)`
  text-align: left;
  font-family: BettingPoliticaExtraBold, sans-serif;
  color: #aaa;
  ${queryText}
`;

const BetResult = styled(P)`
  border-radius: 2px;
  padding: 0.2em 0.5em;
  text-align: left;
  background-color: ${({ $isCancelled, theme }) => ($isCancelled ? '#999' : theme.common.colors.positive)};
`;

const Bonus = styled.p`
  margin: 0;
  flex-wrap: wrap;
  max-width: 80%;
  font-family: BettingPoliticaExtraBold, sans-serif;
  color: #fff;
  position: relative;
  background: linear-gradient(to right, #25900e, #1c9e02);
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const ComboboosterImage = styled.img`
  height: 0.8em;
  width: calc(100% - 0.8em);
  max-width: 100px;
  height: auto;
  display: inline-block;
  margin: 0.2em 0.4em;
`;

const BonusSlice = styled.svg`
  display: block;
  position: absolute;
  top: 0;
  left: 100%;
  height: 100%;
  width: auto;
  fill: #1c9e02;
`;

export type WinModalBetProps = {
  odd: string;
  title: string;
  betTitle: string;
  betResult: string;
  betAmount: string;
  winningsAmount: string;
  sportId: number;
  isCancelled: boolean;
  isBetbuilder?: boolean;
  bonusAmount?: string;
  promotionTitle?: string;
  boosterPercent?: string;
  className?: string;
};

const WinModalBet = ({
  odd,
  title,
  betTitle,
  betResult,
  betAmount,
  winningsAmount,
  sportId,
  isCancelled,
  isBetbuilder,
  bonusAmount,
  promotionTitle,
  boosterPercent,
  className,
}: WinModalBetProps) => (
  <Wrap className={className} $isCancelled={isCancelled}>
    <WrapCol>
      <ColLeft>
        <Title>
          {sportId ? <StyledSportIcon sportId={sportId} /> : <ComboIcon />}
          <SpanEllipsis>{title}</SpanEllipsis>
        </Title>
      </ColLeft>
      {!isCancelled && winningsAmount && (
        <ColRight>
          <WinningsAmount>{winningsAmount}</WinningsAmount>
        </ColRight>
      )}
    </WrapCol>
    <WrapCol>
      <ColLeft>
        {isBetbuilder && <StyledMyMatchIcon />}
        {betTitle && !isBetbuilder && <BetTitle>{betTitle}</BetTitle>}
        {betResult && !isBetbuilder && <BetResult $isCancelled={isCancelled}>{betResult}</BetResult>}
        {!isCancelled && bonusAmount && (
          <Bonus>
            {boosterPercent ? <ComboboosterImage src={combobooster} /> : <Span>{promotionTitle}</Span>}
            <Span>{bonusAmount}</Span>
            <BonusSlice viewBox="0 0 100 100">
              <path d="M 0 0 L 0 100 L 100 0 Z" />
            </BonusSlice>
          </Bonus>
        )}
      </ColLeft>
      <ColRight>
        <P>{betAmount}</P>
        {!isCancelled && <P>{odd}</P>}
      </ColRight>
    </WrapCol>
  </Wrap>
);

export default WinModalBet;
